export const ACTION_LOGIN = "ACTION_LOGIN";
export const ACTION_UPDATE_PASSWORD = "ACTION_UPDATE_PASSWORD";
export const ACTION_GET_TERMS_CONDITIONS = "ACTION_GET_TERMS_CONDITIONS";
export const ACTION_POST_TERMS_CONDITIONS = "ACTION_POST_TERMS_CONDITIONS";